import { render, staticRenderFns } from "./CompanyReport.vue?vue&type=template&id=53663d04"
import script from "./CompanyReport.vue?vue&type=script&lang=js"
export * from "./CompanyReport.vue?vue&type=script&lang=js"
import style0 from "./CompanyReport.vue?vue&type=style&index=0&id=53663d04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports